import Layout from 'partials/layout'
import React from 'react'
import { AboutUsFrame, OurCoursesFrame, UnlockYourLearningFrame } from './counsellorframes'
import styles from './councellorhome.module.scss'
// import students from 'assets/images/students.svg'
// import { ERCInput } from 'components/input'
// import ExperienceCard from 'components/experiencecard'
// import CounsellorChatCard from 'components/counsellorchatcard'
import { ERCText } from 'components/text'
import Dropdown from 'components/dropdown'
import DetailsBox from 'components/detailsbox'
// import { Swiper, SwiperSlide } from 'swiper/react';
import CountUp from 'react-countup'
import studentsStat from '../../../assets/images/statsImg/students-stat.svg'
import contentStat from '../../../assets/images/statsImg/content-stat.svg'
import mockStat from '../../../assets/images/statsImg/mock-stat.svg'
import videoStat from '../../../assets/images/statsImg/video-stat.svg'


const CouncellorHomepage = () => {

    return (
        <Layout mqcolor='#129647'>

            <UnlockYourLearningFrame />
            <section className={styles.statholder} >
                <DetailsBox img={studentsStat} numbers={<><CountUp delay={0.5} end={800000} />+</>} text={'Students'} />
                <DetailsBox img={contentStat} numbers={<><CountUp delay={0.5} end={7000} />+</>} text={'Interactive Content'} />
                <DetailsBox img={mockStat} numbers={<><CountUp delay={0.5} end={1000} />+</>} text={'Mock Questions'} />
                <DetailsBox img={videoStat} numbers={<><CountUp delay={0.5} end={900} />+</>} text={'Learning Videos'} />
            </section>

            <section className={styles.aboutusframe}>
                <AboutUsFrame />
            </section>

            <section className={styles.coursesdiv} >
                <OurCoursesFrame />
            </section>



            {/* <section className={styles.chat} >
                <CounsellorChatCard />
            </section> */}
        
            <section className={styles.faq} >

                <ERCText size='40px' color='#00296B' weight='700' >Frequently Asked Questions</ERCText>
                <div className={styles.faqdropdown}>
                    <Dropdown header={'What is the Lagos State Education Resource Center?'} smallText={'The Lagos State Education Resource Center is a comprehensive online platform aimed at providing educational resources and support to students, teachers, and the community at large. Established in 1967, the Lagos State Education Resource Centre features a library and ICT laboratory for internet access, educational material downloads, exam registration, result checks, and instructional material creation.'} />
                    <Dropdown header={'Who can access the resources on this platform?'} smallText={'The Lagos State Education Resource Center is a comprehensive online platform aimed at providing educational resources and support to students, teachers, and the community at large. Established in 1967, the Lagos State Education Resource Centre features a library and ICT laboratory for internet access, educational material downloads, exam registration, result checks, and instructional material creation.'} />
                    <Dropdown header={'What type of resources are available on the platform?'} smallText={'The Lagos State Education Resource Center is a comprehensive online platform aimed at providing educational resources and support to students, teachers, and the community at large. Established in 1967, the Lagos State Education Resource Centre features a library and ICT laboratory for internet access, educational material downloads, exam registration, result checks, and instructional material creation.'} />
                    <Dropdown header={'Are the resources tailored to specific grade levels or subjects?'} smallText={'The Lagos State Education Resource Center is a comprehensive online platform aimed at providing educational resources and support to students, teachers, and the community at large. Established in 1967, the Lagos State Education Resource Centre features a library and ICT laboratory for internet access, educational material downloads, exam registration, result checks, and instructional material creation.'} />
                    <Dropdown header={'How can teachers integrate these resources into their lesson plans?'} smallText={'The Lagos State Education Resource Center is a comprehensive online platform aimed at providing educational resources and support to students, teachers, and the community at large. Established in 1967, the Lagos State Education Resource Centre features a library and ICT laboratory for internet access, educational material downloads, exam registration, result checks, and instructional material creation.'} />
                </div>

            </section>


        </Layout>
    )
}

export default CouncellorHomepage